import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import SalesDetailsReportComponent from './sales-details-report.component';

let SalesDetailsReportModule = angular
  .module('SalesDetailsReport', [
    uiRouter
  ])
  .component('salesDetailsReport', SalesDetailsReportComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('salesDetailsReport', {
      url: '/un-named-report',
      data: {
        authRequired: true,
        permsRequired: ['sales-details-report']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'salesDetailsReport'
        }
      }
    })
  })
  .name;

export default SalesDetailsReportModule;



// WEBPACK FOOTER //
// ./src/app/pages/sales-details-report/sales-details-report.module.js